module.exports = __webpack_public_path__ + "static/media/Bank Illustration.d038f77d.png";